// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"298":"th-tr","637":"en-tr","673":"zh-tr","756":"zh-Hant-tr"}[chunkId] || chunkId) + "." + {"124":"ccb0b3dc","298":"5397e85b","637":"76d8f460","673":"b412bdf2","700":"8207b498","756":"03284883"}[chunkId] + ".js?[%= hash %]";
};